
export const SHOW_LIFE_PAGE_SUB_NAVIGATION_MENU = 'SHOW_LIFE_PAGE_SUB_NAVIGATION_MENU';

export type LifeSubNavMenuActionType = {
    type: typeof SHOW_LIFE_PAGE_SUB_NAVIGATION_MENU;
    payload: boolean;
}

export function lifeSubNavMenuAction(open: boolean): LifeSubNavMenuActionType {
    return {
        type: SHOW_LIFE_PAGE_SUB_NAVIGATION_MENU,
        payload: open
    };
}
